<template>
 <div v-bind:class="{ articlePicker: true, flipToggle: true, active: active }">

 	<div class="filterPanel">

	 	<div v-on:click="toggleFilter" v-bind:class="{ filterButton: true, disabled: currentArticleSorting != 'all'}">
	 		<span v-if="!filterActive"> {{ $t('showFilter') }}  <i class="fa fa-search"></i> </span>
	 		<span  v-if="filterActive"> </i> {{ $t('hideFilter') }}  <i class="icon-close bold"></i>  </span>
	 	</div> <!-- filterButton -->

	 	<div class="filterButton sortButton">

 			<div v-on:click="sortingActive = !sortingActive" class="currentSorting">
 				<span v-if="currentArticleSorting == 'all'" > {{ $t('allProducts') }} </span>
 				<!--
					// Remove toggle icons as there is only one choice without favourites
					<i v-if="!sortingActive" class="icon-chevron-thin-down"></i>
 					<i v-if="sortingActive" class="icon-chevron-thin-up"></i>
				-->
 			</div> <!-- currentSorting -->

 			<!--
				// Remove favourites as we do not have support for this at the moment
				<div v-bind:class=" { sortList: true, active: sortingActive }">
					<div v-on:click="setSort('all')" v-if="currentArticleSorting != 'all'" class="item">{{ $t('allProducts') }}</div>
					<div v-on:click="setSort('favorites')" v-if="currentArticleSorting != 'favorites'" class="item">{{ $t('myFavorites') }}</div>
				</div>
			-->

 		</div> <!-- sortButton -->

	</div> <!-- filterPanel -->

 	<div v-on:scroll="checkLazy" id="articleScroller" class="listing articleList">

 		<div v-if="chosenFilters && currentArticleSorting == 'all'" class="filterChoices">
 			<div v-for="filter in chosenFilters"
 			v-on:click="removeFilterChoice(filter)"
 			class="chosenFilter hover-fade"> 
			 	{{ filter.title }}
			</div>
 		</div>


  		<div v-if="articles">

  			<div class="favMatch" v-if="currentArticleSorting == 'favorites'" >
  				<span v-if="device.isMobile">
  					{{ $t('favoritesThatMatchMobile') }}
  				</span>

  				<span v-else>
  					{{ $t('favoritesThatMatch') }}
  				</span>
  			</div>

		     <div class="item small-full medium-half large-third smooth"
		     v-for="item in articles"
		     v-if="filterOutUnwantedArticles(item)">

		       	<div class="inner">
					<div v-on:click="pickItem(item)" class="image">
						<div class="imgInner">
					    	<img v-bind:src="getImage(item)" />
					    </div>
					</div>
					<div v-bind:class="{ tags: true, active: articleHasCampaign(item) }">
						<span class="tag">{{ item.campaignBadge }}</span>
					</div>
					<div class="price">
						<span v-html="$t('currencyPrefix')"></span>
						{{ item.price }}
						<span v-html="$t('currencySuffix')"></span>
						<!--
							<div  class="save">
								<i v-on:click="save(item.parent, $event)" v-if="!savedArticles[item.parent]" class="fa fa-heart-o"></i>
								<i v-on:click="unSave(item.parent, $event)" v-if="savedArticles[item.parent]" class="fa fa-heart"></i>
							</div>
						-->
					</div> <!-- price -->
		       	</div> <!-- inner -->

		     </div> <!-- item -->

		     <div v-bind:class="{ lazyLoading: true, active: !lazyDone}">  <loader :loading="true"></loader> </div>
		</div> <!-- if articles -->

		<div class="title" v-if="!articles && noArticles && !loading" v-html="$t('noArticlesMatched', { size: currentSize })"></div>

	  </div> <!-- dataList -->

	  <loader fade-in="fadeIn" fade-out="fadeOut" classes="cover dimmer" :loading="loading"></loader>

 </div> <!-- articlePicker -->

</template>

<script>
require("lodash")

export default {

	data: function(){
		return{
			loading: false,
			active: false,
			articles: false,
			lazyDone: false,
			stopLazy: false,
			lazyLoading: false,
			savedArticlesFetched: false,
			offset: 0,
			page: 1,
			limit: 30,
			savedArticles: {},
			sortingActive: false,
			lastConditions: false,
			imageUrl: this.getCdn(),
			noArticles: false,
			search: "",
			filter: {},
		}
	},

	computed: {

		filterActive(){
  			return this.$store.state.articleFilterActive
  		},

  		currentSize(){
  			return this.$store.state.currentWallFieldSize;
  		},

		currentConditions(){
			return this.$store.state.currentWallFieldConditions;
		},

		filterActive(){
			return this.$store.state.articleFilterActive
		},

		filterAvailable(){
			return this.$store.state.articleFilter != false
		},

		chosenFilters(){
		 	return this.$store.state.chosenArticleFilter
		},

		currentArticleSorting(){
			return this.$store.state.currentArticleSorting
		}

	},

	methods: {

		getWGArticles: function(returnFunction, options){

			var self = this;

			self.noArticles = false;

			// If options
			if(typeof options != 'undefined'){

				// Reset offset
				if(options.resetOffset)
					self.page = 1;

				// Show loading cover
				if(options.loading)
					self.loading = true;

			}

			window.apiHandler['articlesWGR'](function(data){

				// Reset lazydone
				if(!options.dontResetLazyDone)
					self.lazyDone = false;

				// Emit event that tells that articles are loaded
				window.eventHub.$emit('loadedArticles');

				// Return function
        		returnFunction(data);

				// Stop lazyblocker and loading
				self.stopLazy = false;
				self.loading = false;

				// Wait some time before we are showing the no articles text
				// It will also only show if there actually are no articles
				setTimeout(function(){
					self.noArticles = true;
				}, 400);

			},
			{
				page: self.page
			});

		},

		filterOutUnwantedArticles(item){
			
			// Needs to be a poster
			if(item.systemCode != 'poster')
				return false;

			// Extra check, no poster packs 
			if(item.articleNumber.indexOf('SET') != -1)
				return false;

			return true;

	    },

	    save(id, e){
			this.rememberArticle('favorites', id)
			this.getSavedArticles()
			e.stopPropagation();
	    },

	    unSave(id, e){
	    	this.unRememberArticle('favorites', id)
	    	this.getSavedArticles()
	    	e.stopPropagation();
	    },

	    getSearch: function() {

	      	var self = this;

	        // Get articles
			self.getWGArticles(function(data){

				if(!_.isEmpty(data.products)){
					
					if(data.products.items.length < self.limit){
						self.lazyDone = true;
					}

					self.$set(self, 'articles', data.products.items);
				}
				else{
					self.$set(self, 'articles', false);
					self.lazyDone = false;
				}
			}, {
				resetOffset: true,
				loading: true
			});
	    },

	    checkLazy: function(e){

	      var self = this;

	      var container = $(e.target);

	      var scrollTop =  container.scrollTop() // Current scroll position
	      var innerHeight =  container.innerHeight() // Inner height of the element
	      var scrollHeight = container[0].scrollHeight // Height of the content of the element
	      var offset = 650 // The offset we want to use

	      var currentScroll = scrollTop + (innerHeight + offset)

	      if(currentScroll >= scrollHeight) {

	       	if(!this.stopLazy && !self.lazyDone){
	       		this.lazyload();
	       	}
	      }

	    },

		lazyload: function(data){

		  var self = this;

		  if(!self.lazyLoading){

				// Flag lazyloading ongoing
				self.lazyLoading = true;

				// Disable lazy if we have no articles at all
				if(typeof self.articles == 'undefined')
				{
					self.lazyDone = true;
					return false;
				}

				// Make sure we fetch the next page
				self.page++;

				// Get articles
				self.getWGArticles(function(data){

					var articleArray = self.articles;

					// If there are articles
					if(typeof data.products != 'undefined' && data.products.items && !_.isEmpty(data.products.items)){

						// Populate article list with new items
						articleArray.push.apply(articleArray, data.products.items);
					
					}
					// If not stop lazy
					else{
						self.lazyDone = true;
					}

					self.lazyLoading = false;

				}, {
					setFilter: false,
					dontResetLazyDone: true,
					page: self.page
				})
		  }

		},

		pickItem: function(item){

			var currentWallField = this.$store.state.currentWallField
			var chosenArticles = this.$store.state.chosenArticles
			var self = this;

			window.apiHandler['specificArticles'](function(data){

				if(data && data.products && typeof data.products[0] != 'undefined'){
					$.each(data.products[0].combinations, function(index, value){
						
						if(value.size == self.currentSize){

							value.posterImages = data.products[0].posterImages;

							chosenArticles[currentWallField] = value
							self.rememberArticle('chosen', item.productID)
							self.$store.commit('chosenArticles', chosenArticles)
							self.$store.commit('calculatePrice')
							self.trackEvent('article step');
						}

					})
				}

			},
			{
				articles: [item.id]
			});
			

	    },

	    toggleFilter: function(){
	    	window.eventHub.$emit('toggleArticleFilter')
	    },

	    scrollUp: function(){
	    	$("#articleScroller").scrollTop(0)
	    },

		close: function(resetWallfield){
			this.active = false;
			this.articles = false;
			this.lazyDone = false;
			this.stopLazy = false;
			this.lazyLoading = false;
			this.lastSize = false;
			this.lastFormat = false;
			this.resetPickerData()

			if(resetWallfield)
				this.$store.commit('currentWallField', false);

			// Clear filter
			this.$store.commit('chosenArticleFilter', []);

			this.scrollUp();

			window.eventHub.$emit('closeArticleFilter');
		},

		getImage(item){

			let image = false;

			if(typeof item.images[0] != 'undefined' && item.images[0].URL)
				return window.appSettings.productImageUrl + "/" + item.images[0].URL;

		},

		removeFilterChoice(filterChoice){
			window.eventHub.$emit('removeFilterChoice', filterChoice);
		},

		getSavedArticles(){

			var saved = this.$localStorage.get('rememberArticles_favorites', false)
			var savedRelative = {};

			if(saved){
				$.each(saved.split(","), function(index, value){
					savedRelative[value] = true;
				})
			}

			this.$set(this, 'savedArticles', savedRelative)
			this.$set(this, 'savedArticlesFetched', true)

		},

		setSort(sorting){
			this.$store.commit('currentArticleSorting', sorting)
			this.sortingActive = false;

			if(this.filterActive){
				this.toggleFilter()
			}

		}

	},

	created: function () {

    	this.savedArticlesFetched = false
		var self = this;

		// When user clicked pictureWall
		window.eventHub.$on('clickedPictureWallItem', function () {
      		if(self.currentPicker != 'frames'){
				window.eventHub.$emit('openArticlePicker');
			}
		});

		// When opening the picker
		window.eventHub.$on('openArticlePicker', function () {

			// Should open test
			var shouldOpen = true;

			// If picker is already active, we shall check if the conditions has changed or not
			if(self.active)
				if(self.lastConditions && self.lastConditions == self.currentConditions){
					shouldOpen = false;
				}

			if(shouldOpen){

				// Set size
				self.lastConditions = self.currentConditions;

				// Close if open to reload data
				self.close(false);

				// Activate picker
				self.active = true;

			  	// Close
			  	self.closePickers('articlePicker')

			  	// Open
			  	self.$store.commit('currentPicker','articles')
				self.$store.commit('leftTitle', self.$t('yourMotifs'))

				// Get articles
				self.getWGArticles(function(data){

					if(!_.isEmpty(data.products)){
						
						if(data.products.items.length < self.limit){
							self.lazyDone = true;
						}

						self.$set(self, 'articles', data.products.items);
					}
	       			else{
						self.$set(self, 'articles', false);
						self.lazyDone = false;
	       			}
				}, {
					resetOffset: true,
					loading: true
				});
			}
			// If we should not open, make a flash instead
			else{
				
				self.loading = true;

				setTimeout(
					function(){
						self.loading = false;
					}, 200);
			}


		});

		// When a new filter option has been selected
		window.eventHub.$on('filterUpdated', function () {

				self.getWGArticles(function(data){

					if(!_.isEmpty(data.products)){
						
						if(data.products.items.length < self.limit){
							self.lazyDone = true;
						}

						self.$set(self, 'articles', data.products.items);
					}
					else{
						self.$set(self, 'articles', false);
						self.lazyDone = false;
					}
				}, {
					resetOffset: true,
					loading: true
				});

		});

		// Search updated event
		window.eventHub.$on('searchUpdated', function (searchQuery) {
			self.search = searchQuery
			self.$store.commit('searchQuery', searchQuery);
			self.getSearch()
		});

		// Close picker event
		window.eventHub.$on('closePickers', function (type) {
			if(type != 'articlePicker')
				self.close(true);
		});

		if(typeof window.bindedSortingClose == 'undefined')
		{
			$(document).on("click", function(e){

				var clickedInsideSorting = $(e.target).parents(".sortButton").length
				var clickedSortingButton = $(e.target).hasClass("sortButton");

				if(!clickedInsideSorting && !clickedSortingButton){
					self.sortingActive = false
				}

			})

			window.bindedSortingClose = true;

		}

	}
}
</script>

<style lang="scss">
.articlePicker{
	width: 100%;
	height: 0;
	overflow: hidden;
	-webkit-transform: translate3d(-100%,0,0);
	transform: translate3d(-100%,0,0);
	-webkit-transition: -webkit-transform 0.2s;
	transition: -webkit-transform 0.2s;
	-o-transition: transform 0.2s;
	transition: transform 0.2s;
	transition: transform 0.2s, -webkit-transform 0.2s;
	-webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
	-o-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
	transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
	z-index: 5;

	.loader.dimmer{
    	background: rgba(255, 255, 255, 0.96);
    }

    /* Title texts */
    .title{
    	margin: 10px auto 10px auto;
	    text-align: center;
	    max-width: 266px;
	    line-height: 23px;
	    text-transform: uppercase;
	    padding: 10px;
	   	color: #a9a9a9;
    	font-size: 12px;
    }

    .sortButton{
    	float: left;
    }

    .sortList{
    	position: absolute;
	    z-index: 9;
	    background: white;
	    width: 100%;
	    padding: 5px;
	    display: none;

	    .item:hover{
	    	cursor: pointer;
	    	background: #f3f3f3;
	    }

	    &.active{
	    	display: block;
	    }

    }

    .filterButton{
	    width: 50%;
	    float: right;
	    border-bottom: 1px solid #eaeaea;
	    height: 40px;
	    text-align: center;
	    line-height: 40px;
	    font-size: 11px;
	    border-left: 1px solid #eaeaea;
	    text-transform: uppercase;
	    cursor: pointer;
	    border-top: 1px solid #EAEAEA;
	    margin-top: 9px;
	    position: relative;

	    &.disabled{
	    	color: #e2e2e2;
	    	pointer-events: none;
	    }

	    .fa-search{
	    	margin-left: 5px;
	    }

	    /* Mobile and tablet */
	    @media screen and (max-width: 1024px) {
	    	width: 100%;

	    	&:last-of-type{
	    		margin-top: 0;
	    		border-top: 0;
	    	};

	    }

	    /* Mobile */
    	@media screen and (max-width: 812px) {
    		 margin-top: 0;
		    height: 30px;
		    line-height: 30px;
		    font-size: 9px;
    	}
    }

    .filterChoices{
    	padding: 18px 18px 0px 10px;
    	margin-bottom: -5px;

    	/* Mobile */
    	@media screen and (max-width: 812px) {
    		padding: 0;
    		margin-top: 11px;
    	}
    }

    .chosenFilter{
    	display: inline-block;
	    font-size: 11px;
	    padding: 5px 7px;
	    background: rgba(224, 224, 224, 0.53);
	    margin-right: 7px;
	    border-radius: 2px;
	    margin-bottom: 8px;
	    cursor: pointer;

	    /* Mobile */
    	@media screen and (max-width: 812px) {
    		padding: 5px 7px;
    		font-size: 10px;
    		width: 100%;
    		margin-bottom: 0;

    		.chosenTitle{
    			width: calc(100% - 14px);
    			float: left;
    			display: block;
    			float: left;
    			white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
    		}

    		i{
    			float: right;
    			margin-top: 2px;
    			margin-right: 5px;
    		}
    	}
    }

}

.articleList{

    height: calc(100% - 125px);
    overflow: scroll;
    float: left;
    width: 100%;
    padding: 0px 10px 7px 10px;

    .item{
		text-align: center;
		cursor: pointer;
		margin-bottom: 10px;
		
		padding: 0;

		.inner{
			padding: 1px;
		}

		/* Mobile */
		@media screen and (max-width: 812px) {
			margin-bottom: 0;
		}

		/* Medium desktops */
		@media screen and (min-width: 1200px) {
			 padding: 2px;
		}

		/* Large desktops */
    	@media screen and (min-width: 1440px) {
    		padding: 5px;
    	}

    }

    .tags{
    	margin-bottom: 10px;
    	visibility: hidden;

    	&.active{
    		visibility: visible;
    	}

    	/* Mobile */
		@media screen and (max-width: 812px) {
			display: none;
			margin-bottom: 5px;

			&.active{
				display: block;
			}
		}

    	.tag{
    		font-size: 10px;
		    background: #000;
		    color: #fff;
		    padding: 2px 5px;
		    font-family: "Lato";
    	}
    }

    .save{
    	display: inline-block;
    	margin-left: 10px;

    	&:hover{
		  opacity: 0.8;
		}

		@media screen and (max-width: 812px) {
			padding: 5px 3px;
			display: inline-block;
		    margin-left: 8px;
		    font-size: 18px;
		}
    }

    .image{
    	display: table;
    	width: 100%;

    	&:hover{
		  opacity: 0.8;
		}

    	height: 94px;

    	/* Large desktops */
    	@media screen and (min-width: 1440px) {
    		height: 130px;
    	}

    	/* Very large desktops */
    	@media screen and (min-width: 1740px) {
    		height: 153px;
    	}

    	/* Very very large desktops */
    	@media screen and (min-width: 1840px) {
    		height: 166px;
    	}

    	/* Largest desktops */
    	@media screen and (min-width: 2000px) {
    		height: 215px;
    	}

    	/* Tablets and desktop pop effect */
		@media screen and (min-width: 1024px) {
		 	&:active{
				img{
					transform: scale(1.1);
				}
		  	}
		}

    	img{
    		width: 100%;
    		height: auto;
			-webkit-box-shadow: 0 0 5px -3px;
    		box-shadow: 0 0 5px -3px;
    	}

    	.imgInner{
    		display: table-cell;
    		vertical-align: middle;
    	}
    }

    .name{
      font-size: 12px;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      display: none;
      text-overflow: ellipsis;
    }

    .price{
      font-weight: 700;
      font-family: "Lato";
      font-size: 12px;
    }

    .slick-slide{
      border: 0px;
    }

    .slick-slide img{
      max-width: 100%;
      /*max-height: 117px;*/
      max-height: 68px;
      display: inline-block;
    }

    .lazyLoading{
		text-align: center;
		float: left;
		font-size: 22px;
		width: 100%;
		padding: 15px;
		margin-bottom: 60px;
		visibility: hidden;

		&.active{
			visibility: visible;
			position: relative;
			bottom: -75px;
			right: 50%;
		}
    }

    .favMatch{
	    font-size: 12px;
	    text-align: center;
	    margin-top: 19px;
		margin-bottom: -3px;
	    color: #929292;
	    text-transform: uppercase;
    }
}

.articlePicker.active{
	-webkit-transform: translate3d(0,0,0);transform: translate3d(0,0,0);
	height: calc(100% - 75px);
	top: 75px;


	@media screen and (max-width: 844px) {
		top: 25px;
		height: calc(100% - 25px);
	}
}

</style>



// WEBPACK FOOTER //
// ArticlePicker.vue?f573078e